/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as sis from './SISApp'
import { componentApi, loadTranslations } from 'common'


export class K12GradReqGradeLayoutApi {
  async GetDataObject(gradReqResultGU : string) : Promise<sis.RowData> {
    return await componentApi.call('sis', 'sis-k12-gradreq-grade-layout', 'K12GradReqGradeLayoutApi', 'GetDataObject', {
      gradReqResultGU,
    });
  }
}
export default new K12GradReqGradeLayoutApi()
